
import Tags from '../Tags'

import { DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from './PopularSearchBlock.constants'
import translations from './PopularSearchBlock.translations'

export default {
  components: {
    Tags,
  },

  props: {
    tags: {
      type: Array,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
  },
}
